export const tvPagePath = '/tv'
export const presentFollowingId = 'all'
export const tvDataKey = 'tvData'
export const playerErrorLicenseHasExpired = 6014
export const playerErrorLicenseRequestFailed = 6007
export const playbackCatchupFlag = 1
export const availabilityWindowOverride = 1000
export const bufferingGoal = 10
export const rebufferingGoal = 7
export const channelFieldHeight = 102
export const presentFollowingDuration = 80
export const PRESENT_FOLLOWING_REFRESH_INTERVAL = 30 * 60 * 1000
export const PRESENT_FOLLOWING_ACTUAL_DATE_CORRECTION = 2 * 3600
export const PRESENT_FOLLOWING_PROGRAMS_COUNT = 15
export const PRESENT_FOLLOWING_DATE_CORRECTION = 6000
export const playerPosterUrl =
    'https://github.com/picasso-one/dottv-web/assets/135114936/59e4acaa-e21c-4a7c-b3a9-0bd637ef6793'
